import * as actionTypes from "../actionTypes";
import * as api from "../../api/index";
import { toast } from "react-toastify";

export const GetPlans = () => async (dispatch) => {
  try {
    const { data } = await api.getBillingPlans();
    dispatch({ type: actionTypes.GET_PLANS, payload: data });
  } catch (error) {
    console.warn("Failed to load billing plans", error);
  }
};

/**
 * LemonSqueezy checkout flow.
 * Returns { checkout_url, internal_order_id } — caller must redirect to checkout_url.
 */
export const CreateCheckout = (planId, billingPeriod, successUrl) => async () => {
  const { data } = await api.createCheckout(planId, billingPeriod, successUrl);
  return data;
};

/**
 * Called after user returns from LemonSqueezy checkout.
 * Confirms payment with backend and refreshes subscription.
 */
export const ConfirmOrder = (internalOrderId, lsOrderId) => async (dispatch) => {
  const { data } = await api.confirmOrder(internalOrderId, lsOrderId);
  if (data.success) {
    try {
      const { data: profile } = await api.getMyProfile();
      dispatch({ type: actionTypes.UPDATE_SUBSCRIPTION, payload: profile.subscription });
    } catch (_) {}
    toast.success("Subscription activated! Enjoy your plan.");
  }
  return data;
};

/**
 * Cancel Pro Plus subscription.
 */
export const CancelSubscription = () => async (dispatch) => {
  const { data } = await api.cancelSubscription();
  if (data.success) {
    try {
      const { data: profile } = await api.getMyProfile();
      dispatch({ type: actionTypes.UPDATE_SUBSCRIPTION, payload: profile.subscription });
    } catch (_) {}
    toast.info("Subscription cancelled. You retain access until the end of your billing period.");
  }
  return data;
};

// ── Legacy Razorpay actions (kept for switchability) ─────────────────────────

export const CreateOrder = (planId, billingPeriod) => async () => {
  const { data } = await api.createPaymentOrder(planId, billingPeriod);
  return data;
};

export const VerifyAndActivate = (payload) => async (dispatch) => {
  const { data } = await api.verifyPayment(payload);
  if (data.success) {
    try {
      const { data: profile } = await api.getMyProfile();
      dispatch({ type: actionTypes.UPDATE_SUBSCRIPTION, payload: profile.subscription });
    } catch (_) {}
    toast.success("Subscription activated! Enjoy your plan.");
  }
  return data;
};

